export const ADMIN_PATH = '/'
export const DASHBOARD_BREADCRUMB = 'Dashboard'
export const REPORT_SITE_PATH = '/reports/k8?site='
export const SCHOOL_SUMMARY_BREADCRUMB = 'School Overview'
